export default __webpack_public_path__ + "static/media/icomoon.c4281646.svg";